<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img
            fluid
            src="@/assets/images/logo/Udara360-logo.png"
            class="logo"
          />
        </b-link>

        <b-card-title class="mb-1">
          {{ $t('Reset Password') }}🔒
        </b-card-title>
        <b-card-text class="mb-2">
          {{ $t('Your new password must be different from previously used passwords') }}
        </b-card-text>

        <!-- form -->
        <b-card>
          <Alert
            :show="showFormError"
            :message="errorMessage"
          />
          <!-- form -->
          <validation-observer ref="changePasswordForm">
            <b-form>
              <b-row>
                <!-- Token -->
                <b-col md="12">
                  <small
                    class="form-text text-muted ml-5"
                    style="margin-bottom: -20px;"
                  >
                    {{ $t('Please kindly check your email address for your Token.') }}
                  </small>
                  <InputField
                    id="user-token"
                    v-model="userDetails.userToken"
                    :label="$t('Token')"
                    :placeholder="$t('Enter your token')"
                    :error-name="$t('Token')"
                    rules="required"
                  />
                </b-col>
                <!--/ Token -->
                <!-- new password -->
                <b-col md="12">
                  <InputPasswordField
                    id="new-password"
                    v-model="userDetails.newPassword"
                    :label="$t('New Password')"
                    :placeholder="$t('New Password')"
                    :error-name="$t('New password')"
                    rules="required|min:6|upperCaseChar|lowerCaseChar|numberVal|specialChar"
                    vid="newPassword"
                  />
                </b-col>
                <!--/ new password -->

                <!-- retype password -->
                <b-col md="12">
                  <InputPasswordField
                    id="retype-password"
                    v-model="userDetails.confirmNewPassword"
                    :label="$t('Retype Password')"
                    :placeholder="$t('Retype Password')"
                    :error-name="$t('Retype password')"
                    rules="required|confirmed:newPassword"
                  />
                </b-col>
              </b-row>
              <!--/ retype password -->

              <!-- Security Question 1 -->
              <b-row class="match-height">
                <b-col
                  md="12"
                  class="mt-3"
                >
                  <b-card-title class="text-title">
                    {{ $t('Setup your security questions to further secure your account.') }}
                  </b-card-title>
                  <div class="business-card">
                    <b-row>
                      <b-col md="12">
                        <SwitchButton
                          v-model="enableCustomQuestion"
                          :label="$t('Do you wish to create your own questions?')"
                          name="enable-custom-question"
                          class="mt-2"
                          @input="onChangeEventHandler(enableCustomQuestion)"
                        />
                      </b-col>
                    </b-row>
                    <app-collapse
                      v-if="enableCustomQuestion === false"
                      class="business-items"
                      type="margin"
                      accordion
                    >
                      <b-row class="match-height">
                        <b-col md="12">
                          <SelectField
                            id="security-question1"
                            v-model="QuestionsAndAnswers.question1"
                            :label="$t('Security Question 1')"
                            :options="securityQuestionOptions"
                            :error-name="$t('Security question 1')"
                            rules="required"
                            :reduce="option => option"
                            item="label"
                            :placeholder="$t('Select a question')"
                            :set-selected="removeItem"
                          />
                        </b-col>
                        <b-col md="12">
                          <InputField
                            id="answered-question-1"
                            v-model="QuestionsAndAnswers.answer1"
                            :label="$t('What\'s your answer?')"
                            :placeholder="$t('Enter your answer')"
                            type="text"
                            rules="required|min:2|max:250"
                            error-name="security answer 1"
                          />
                        </b-col>
                      </b-row>
                      <!-- Security Question 1-->

                      <!-- Security Question 2 -->
                      <b-row class="match-height">
                        <b-col md="12">
                          <SelectField
                            id="security-question2"
                            v-model="QuestionsAndAnswers.question2"
                            :label="$t('Security Question 2')"
                            :options="securityQuestionOptions"
                            :error-name="$t('Security question 2')"
                            rules="required"
                            :reduce="option => option"
                            item="label"
                            :placeholder="$t('Select a question')"
                            :set-selected="removeItem"
                          />
                        </b-col>
                        <b-col md="12">
                          <InputField
                            id="answered-question-2"
                            v-model="QuestionsAndAnswers.answer2"
                            :label="$t('What\'s your answer?')"
                            :placeholder="$t('Enter your answer')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security answer 2')"
                          />
                        </b-col>
                      </b-row>

                      <!-- Security Question 3 -->
                      <b-row class="match-height">
                        <b-col md="12">
                          <SelectField
                            id="security-question3"
                            v-model="QuestionsAndAnswers.question3"
                            :label="$t('Security Question 3')"
                            :options="securityQuestionOptions"
                            :error-name="$t('Security question 3')"
                            rules="required"
                            :reduce="option => option"
                            item="label"
                            :placeholder="$t('Select a question')"
                            :set-selected="removeItem"
                          />
                        </b-col>
                        <b-col md="12">
                          <InputField
                            id="answered-question-3"
                            v-model="QuestionsAndAnswers.answer3"
                            :label="$t('What\'s your answer?')"
                            :placeholder="$t('Enter your answer')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security answer 3')"
                          />
                        </b-col>
                      </b-row>
                    </app-collapse>

                    <app-collapse
                      v-if="enableCustomQuestion === true"
                      class="business-items"
                      type="margin"
                      accordion
                    >
                      <b-row class="match-height">
                        <b-col md="12">
                          <InputField
                            id="security-question1"
                            v-model="QuestionsAndAnswers.question1"
                            :label="$t('Security Question 1')"
                            :placeholder="$t('Security question')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security question 1')"
                          />
                        </b-col>
                        <b-col md="12">
                          <InputField
                            id="answered-question-1"
                            v-model="QuestionsAndAnswers.answer1"
                            :label="$t('What\'s your answer?')"
                            :placeholder="$t('Enter your answer')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security answer 1')"
                          />
                        </b-col>
                      </b-row>
                      <b-row class="match-height">
                        <b-col md="12">
                          <InputField
                            id="security-question2"
                            v-model="QuestionsAndAnswers.question2"
                            :label="$t('Security Question 2')"
                            :placeholder="$t('Security question')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security question 2')"
                          />
                        </b-col>
                        <b-col md="12">
                          <InputField
                            id="answered-question-2"
                            v-model="QuestionsAndAnswers.answer2"
                            :label="$t('What\'s your answer?')"
                            :placeholder="$t('Enter your answer')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security answer 2')"
                          />
                        </b-col>
                      </b-row>
                      <b-row class="match-height">
                        <b-col md="12">
                          <InputField
                            id="security-question3"
                            v-model="QuestionsAndAnswers.question3"
                            :label="$t('Security Question 3')"
                            :placeholder="$t('Security question')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security question 3')"
                          />
                        </b-col>
                        <b-col md="12">
                          <InputField
                            id="answered-question-3"
                            v-model="QuestionsAndAnswers.answer3"
                            :label="$t('What\'s your answer?')"
                            :placeholder="$t('Enter your answer')"
                            type="text"
                            rules="required|min:2|max:250"
                            :error-name="$t('Security answer 3')"
                          />
                        </b-col>
                      </b-row>

                    </app-collapse>
                  </div>
                </b-col>
              </b-row>

              <!-- submit button -->
              <b-row class="m-1">
                <Button
                  :label="$t('Save')"
                  size="lg"
                  block
                  :loading="isLoading"
                  :disabled="isDisabled"
                  @click="changeUserPassword"
                />
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  class="ml-1"
                  @click="resetForm"
                >
                  {{ $t('Cancel') }}
                </b-button>
                <!--/ buttons -->
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>

        <p class="text-center mt-2">
          <b-link :to="{name:'auth-login'}">
            <feather-icon icon="ChevronLeftIcon" />  {{ $t('Back to login') }}
          </b-link>
        </p>

      </b-card>
      <!-- /Reset Password v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  BRow,
  BCol,
  BCard,
  BImg,
  BLink,
  BCardText,
  BCardTitle,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { toastAlert } from '@core/mixins/toast'
import { mapActions } from 'vuex'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import Button from '../../components/button/Button.vue'
import Alert from '../../components/alert/Alert.vue'
import InputPasswordField from '../../forms/InputPasswordField.vue'
import { securityQuestions } from '../../../helpers/data'
import InputField from '../../forms/InputField.vue'
import SelectField from '../../forms/SelectField.vue'
import SwitchButton from '../../components/switch/Switch.vue'

export default {
  components: {
    BImg,
    BLink,
    BButton,
    BForm,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    InputPasswordField,
    SelectField,
    InputField,
    ValidationObserver,
    Button,
    Alert,
    SwitchButton,
    AppCollapse,
  },
  directives: {
    Ripple,
  },
  mixins: [toastAlert, sweetAlert],
  data() {
    return {
      userDetails: {
        email: '',
        newPassword: '',
        confirmNewPassword: '',
        userToken: '',
      },
      QuestionsAndAnswers: {
        question1: '',
        question2: '',
        question3: '',
        answer1: '',
        answer2: '',
        answer3: '',
      },
      email: '',
      isLoading: false,
      isDisabled: false,
      showFormError: false,
      errorMessage: '',
      required,
      status: '',
      enableCustomQuestion: false,
      securityQuestionOptions: securityQuestions.map(item => ({
        ...item,
        label: this.$t(item.label),
        value: this.$t(item.value),
      })),
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    ...mapActions({
      modifyPasswordWithSecurityQuestions:
        'auth/modifyPasswordWithSecurityQuestions',
    }),
    removeItem(index) {
      const indexNumber = this.securityQuestionOptions.indexOf(index)
      this.securityQuestionOptions.splice(indexNumber, 1)
    },
    getUser() {
      const { user } = this.$route.params
      if (user) {
        this.email = user.username
      } else {
        this.$router.push({ name: 'auth-login' })
      }
    },
    onChangeEventHandler(event) {
      if (event === true) {
        this.QuestionsAndAnswers = { ...null }
      } else {
        this.QuestionsAndAnswers = { ...null }
      }
    },

    changeUserPassword() {
      this.$refs.changePasswordForm.validate().then(async success => {
        if (success) {
          try {
            this.showFormError = false
            this.isDisabled = true
            this.isLoading = true
            const questionAndAnswers = this.enableCustomQuestion
              ? {
                ...this.QuestionsAndAnswers,
                question1: {
                  label: this.QuestionsAndAnswers.question1,
                  value: this.QuestionsAndAnswers.question1,
                },
                question2: {
                  label: this.QuestionsAndAnswers.question2,
                  value: this.QuestionsAndAnswers.question2,
                },
                question3: {
                  label: this.QuestionsAndAnswers.question3,
                  value: this.QuestionsAndAnswers.question3,
                },
              }
              : { ...this.QuestionsAndAnswers }

            await this.modifyPasswordWithSecurityQuestions({
              ...this.userDetails,
              ...questionAndAnswers,
              email: this.email,
            }).then(() => {
              this.$router.push({ name: 'auth-login' })
              this.toastAlert({
                title: this.$t('Success'),
                icon: 'CoffeeIcon',
                variant: 'success',
                text: this.$t('You have successfully changed your password, please login and continue..'),
              })
            })
            this.isDisabled = false
            this.isLoading = false

            return true
          } catch (error) {
            this.showFormError = true
            error.response.data.errors.forEach(responseError => {
              this.errorMessage = responseError.errorMessage
            })
          } finally {
            this.isDisabled = false
            this.isLoading = false
          }
        }
        return false
      })
    },
    resetForm() {
      this.userDetails = { ...null }
      this.QuestionsAndAnswers = { ...null }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
.auth-wrapper.auth-v1 .auth-inner {
  max-width: 700px !important;
}
</style>
